import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the bundle and promotion api
 */
export class BundlePromotionService extends BaseService {

	constructor() {	
		super();
	}
	
	async getBundles(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}		
		var data = await this.makeGETRequest('/api/resource/bundles' + params);		
		return data;		
	}
	
	async getBundle(bundleCode) {
		var data = await this.makeGETRequest('/api/resource/bundles/' + bundleCode);		
		return data;		
	}
	
	async getBundleDetail(bundleCode) {
		var data = await this.makeGETRequest('/api/resource/bundles/' + bundleCode + '/detail');		
		return data;		
	}	
	
	async saveBundle(bundleModel, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/bundles/' + bundleModel.bundle.bundleCode, bundleModel);
		} else {
			saved = await this.makePOSTRequest('/api/resource/bundles', bundleModel);
		}
		return saved;		
	}	
	
	async deleteBundle(bundleCode) {
		var data = await this.makeDELETERequest('/api/resource/bundles/' + bundleCode);		
		return data;		
	}	
	
	async getPromotions(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}		
		var data = await this.makeGETRequest('/api/resource/promotions' + params);		
		return data;		
	}
	
	async getPromotion(promotionCode) {
		var data = await this.makeGETRequest('/api/resource/promotions/' + promotionCode);		
		return data;		
	}
	
	async getPromotionDetail(promotionCode) {
		var data = await this.makeGETRequest('/api/resource/promotions/' + promotionCode + '/detail');		
		return data;		
	}	
	
	async savePromotion(promotion, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/promotions/' + promotion.promotionCode.promotionCode, promotion);
		} else {
			saved = await this.makePOSTRequest('/api/resource/promotions', promotion);
		}
		return saved;		
	}	
	
	async deletePromotion(promotionCode) {
		var data = await this.makeDELETERequest('/api/resource/promotions/' + promotionCode);		
		return data;		
	}	
	
}
